import React from 'react';

interface ConfidenceGaugeProps {
  value: number; // 0-100
}

const ConfidenceGauge: React.FC<ConfidenceGaugeProps> = ({ value }) => {
  const clampedValue = Math.max(0, Math.min(100, value));

  const getColor = () => {
    if (clampedValue >= 75) return 'bg-emerald-500';
    if (clampedValue >= 50) return 'bg-teal-500';
    if (clampedValue >= 25) return 'bg-amber-500';
    return 'bg-red-500';
  };

  const getTextColor = () => {
    if (clampedValue >= 75) return 'text-emerald-400';
    if (clampedValue >= 50) return 'text-teal-400';
    if (clampedValue >= 25) return 'text-amber-400';
    return 'text-red-400';
  };

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1 h-2 bg-slate-700 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${getColor()}`}
          style={{ width: `${clampedValue}%` }}
        />
      </div>
      <span className={`text-lg font-bold min-w-[3rem] text-right ${getTextColor()}`}>
        {clampedValue}%
      </span>
    </div>
  );
};

export default ConfidenceGauge;
